import { usePremium } from '@/context/PremiumContext';

// Fail closed while the shared public catalog loads. One server-side switch
// controls navigation, access, Premium presentation and background processing.
export default function useFantasyAvailability() {
  return usePremium().catalog?.availability?.fantasy === true;
}
